export enum SystemEventType {
    NONE = 0,
    PROCESS_INCREASE_THREADS_COUNT = 1,
    PROCESS_DECREASE_THREADS_COUNT = 2,
    PROCESS_CLEAR_ACTIVE_THREADS = 3,
    PROCESS_AUTO_START = 4,
    PROCESS_CREATED = 5,
    PROCESS_START = 6,
    PROCESS_RESTART = 7,
    PROCESS_STOP = 8,
    PROCESS_UPDATED = 9,
    PROCESS_FINISH = 10,
    PROCESS_DELETED = 11,
    PROCESS_ARCHIVED = 12,
    PROCESS_RESTORED = 13,
    PROCESS_PENDING_START = 14,
    PROCESS_CLEAR_STUCK_THREAD = 15,

    ZONING_CODE_ADDED = 100,
    ZONING_CODE_STATUS_CHANGED = 101,

    // Property Record Events
    BULK_CREATE_FAILED = 201,
    BULK_UPDATE_FAILED = 202,
    PRS_INCORRECT_SORL_AU = 203,

    // Calculation Result Events
    CR_DATA_ISSUE_ERROR = 300
}

const SYSTEM_EVENT_TYPE_DICTIONARY = [
    'None',
    'Process threads count increased',
    'Process threads count decreased',
    'Process active threads cleared',
    'Process started automatically',
    'Process created',
    'Process started',
    'Process restarted',
    'Process stopped',
    'Process updated',
    'Process finished',
    'Process deleted',
    'Process archived',
    'Process restored',
    'Process pending start',
    'Stuck thread was cleared'
];
SYSTEM_EVENT_TYPE_DICTIONARY[SystemEventType.ZONING_CODE_ADDED] = 'Zoning Code added';
SYSTEM_EVENT_TYPE_DICTIONARY[SystemEventType.ZONING_CODE_STATUS_CHANGED] = 'Zoning Code status changed';
SYSTEM_EVENT_TYPE_DICTIONARY[SystemEventType.BULK_CREATE_FAILED] = 'Failed to create multiple Property Records';
SYSTEM_EVENT_TYPE_DICTIONARY[SystemEventType.BULK_UPDATE_FAILED] = 'Failed to update multiple Property Records';
SYSTEM_EVENT_TYPE_DICTIONARY[SystemEventType.PRS_INCORRECT_SORL_AU] = 'Failed to created Allowed Uses hashes for Solr';
SYSTEM_EVENT_TYPE_DICTIONARY[SystemEventType.CR_DATA_ISSUE_ERROR] = 'Calculation Result has data issue error (Uses)';

export function getPrettyEventType(taskStatus: number): string {
    return SYSTEM_EVENT_TYPE_DICTIONARY[taskStatus];
}
